import { gql, useQuery } from '@apollo/client'

import {
  ArtistItemOrdersConnectionFragmentDoc,
  ConsoleItemOrdersQuery,
  ConsoleItemOrdersQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { data, loading, fetchMore } = useQuery<
    ConsoleItemOrdersQuery,
    ConsoleItemOrdersQueryVariables
  >(QUERY)

  return {
    state: {
      artistId: user?.uid ?? '',
      currentUser: user,
      hasNextPage: !!data?.organizationArtistItemOrders?.pageInfo.hasNextPage,
      items: data?.organizationArtistItemOrders ?? null,
      loading,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor:
                data?.organizationArtistItemOrders?.pageInfo?.endCursor || null,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query ConsoleItemOrders($pageInput: PageInputDate) {
    organizationArtistItemOrders(pageInput: $pageInput) {
      ...ArtistItemOrdersConnection
    }
  }
  ${ArtistItemOrdersConnectionFragmentDoc}
`
